// extracted by mini-css-extract-plugin
export var background = "styles-module--background--4d489";
export var content = "styles-module--content--8eab2";
export var footer = "styles-module--footer--40567";
export var foreground = "styles-module--foreground--35ab1";
export var header = "styles-module--header--150f8";
export var positioner = "styles-module--positioner--b3bde";
export var wrapper = "styles-module--wrapper--710fb";